/**
 * DOWNLOAD COMPANIES VIEW TEMPLATE
 *
 * @version 0.1
 */

import React from 'react';
import { FormattedMessage } from 'react-intl';

function DownloadCompanies({ downloadFile }) {

    return (

        <div className="upload-wizard__button-container">

            <div className="card-title">
                <FormattedMessage id="Entities_Steps_UIText_batchUpload.Step1Heading" />
            </div>

            <div className="card-image step-one"></div>

            <div className="step-heading">
                <FormattedMessage id="Entities_Steps_UIText_batchUpload.stepArrow1" />
            </div>

            <p><FormattedMessage id="Entities_Steps_UIText_batchUpload.step1Instruction" /></p>

            <div className="button-wrapper">
                <button type="button"
                        className="button-primary-lg upload-wizard__buttons upload-wizard__buttons--download-template"
                        onClick={downloadFile}>
                    <FormattedMessage id="Entities_Steps_UIText_batchUpload.buttonDownloadTemplate" />
                </button>
            </div>
        </div>

    );

};

export default DownloadCompanies;




// WEBPACK FOOTER //
// ./src/scripts/pages/BatchUpload/submodules/InitialStage/DownloadCompanies.jsx